import request from 'superagent'
import { apiConstants } from './constants/apiConstants'
import { removeTrailingSlashes } from './helper'
import serverData from './utils/server-data'
import _ from 'lodash'

const getCSRFTokenFromCookie = (cookieName) => {
  const csrfCookie = serverData.isSSOEnabled
    ? document.cookie
        .split(/;\s*/g)
        .map((cookie) => /(.*?)=(.*)/.exec(cookie))
        .filter((cookie) => cookie[1] === cookieName)
    : ''

  const csrfToken = csrfCookie ? decodeURIComponent(csrfCookie[0][2]) : null
  return csrfToken
}

const getCSRFToken = () => {
  const csrf = document.body.getAttribute('data-csrf')
  return csrf || getCSRFTokenFromCookie('csrfToken')
}

/*eslint-disable */
function search(url, params, callback) {
  const req = request
    .post(removeTrailingSlashes(url))
    .send(params)
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
  req.end((err, res) => {
    if (err) {
      callback(err)
    } else {
      callback(res)
    }
  })
  return req
}
/*eslint-enable */

function getUploadReq(url) {
  return request
    .post(removeTrailingSlashes(url))
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
    .on('progress', (e) => {
      console.log('Percentage done: ', e.percent)
    })
}

function upload(url, files) {
  return files
    .reduce((result, file) => result.attach(file.name, file), getUploadReq(url))
    .then(console.log)
    .catch(console.error)
}

/*eslint-disable */
function singleUpload(url, file, replace) {
  const keepSessionAlive = setInterval(() => {
    request
      .get(`${apiConstants.URLPrefix}${apiConstants.URLToKeepSessionAlive}`)
      .set('Access-Control-Allow-Origin', '*')
      .set('x-csrf-token', getCSRFToken())
      .end()
  }, apiConstants.SessionWakeInterval)

  return request
    .post(removeTrailingSlashes(url))
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
    .set('Content-Type', 'application/octet-stream')
    .query({ replace })
    .send(file)
    .on('progress', (e) => {
      if (e.percent === 100) clearInterval(keepSessionAlive)
    })
}
/*eslint-enable */

function sendGetRequest(url, params) {
  return request
    .get(removeTrailingSlashes(url))
    .query(params)
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
}

function sendPostRequest(url, params) {
  return request
    .post(removeTrailingSlashes(url))
    .send(params)
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
}

function sendPutRequest(url, params) {
  return request
    .put(removeTrailingSlashes(url))
    .send(params)
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
}

function sendPatchRequest(url, params) {
  return request
    .patch(removeTrailingSlashes(url))
    .send(params)
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
}

function sendDeleteRequest(url, params) {
  return request
    .del(removeTrailingSlashes(url))
    .send(params)
    .set('Access-Control-Allow-Origin', '*')
    .set('x-csrf-token', getCSRFToken())
}

function trackFPTI(user, actions, file) {
  const fileType = _.get(file, 'fileType', '')
  const pageAction = _.reduce(
    actions,
    function (result, action) {
      return `${result}${action}:`
    },
    '',
  )

  if (window.PAYPAL && window.PAYPAL.analytics) {
    const options = {
      data: {
        pgrp: `dropzone:${user.accType}`,
        page: `dropzone:${pageAction}${fileType !== '' ? `${fileType}:` : ''}${
          user.accType
        }`,
        link: _.last(actions),
        comp: 'filevaultnodeweb',
      },
    }
    window.PAYPAL.analytics.instance.recordClick(options)
  }
}

const caller = {
  search,
  singleUpload,
  upload,
  trackFPTI,
  sendGetRequest,
  sendPostRequest,
  sendPutRequest,
  sendPatchRequest,
  sendDeleteRequest,
}

export default caller
